/**
 * Offcanvas view for adding new sales billing
 * 
 * Properties:
 * 
 *      showDelayedNotification:    function, callback to display delay notification (e.g. item has been saved)
 */


import React, {useState, useEffect} from 'react';
import FormItem from '../../../components/FormItem';
import Notification from "../../../components/Notification";
import OffcanvasHeader from '../../../components/OffcanvasHeader';
import t from '../../../helpers/t';
import { Biscuit } from '../../../../utils';
import { getApiHost } from '../../../../Sync';
import { _, moment } from '../../../../../vendor';
import * as FileSaver from '../../../../../vendor/FileSaver';
import { useSelector, locationActions, accumulatedInvoiceActions } from "inbooma-api";


const AddSalesBillingsView = (props) => {

    let language = Biscuit.get('user.lang').replace('-','_');

    const [initialized,setInitialized] = useState(false);
    const [isSaving,setIsSaving] = useState(false);
    const _postSalesBilling = useSelector(state => state.accumulated_invoices_data.addAccumulatedInvoice);
    const [shouldClose,setShouldClose] = useState(false);
    const [monthList,setMonthList] = useState([]);
    const [selectedMonth,setSelectedMonth] = useState("");

    const [selectedDate,setSelectedDate] = useState(null);
    const [selectedBegin,setSelectedBegin] = useState(null);
    const [selectedEnd,setSelectedEnd] = useState(null);
    const [selectedLocation,setSelectedLocation] = useState(null);
    const [locationsPending,setLocationsPending] = useState(false);
    const _locations = useSelector(state => state.locations_data.locations);
    const [locations,setLocations] = useState([]);

    const [notification,setNotification] = useState({
        message: "",
        show: false,
        link: "",
        linkContent: "",
        linkHandler: ""
    });

    const onCloseNotificationHandler = () => {

        setNotification({
            ...notification,
            show: false
        });
    };

    const getNameOfMonth = (m) => {

        switch (m) {
            case 0:
                return t('january');
            case 1:
                return t('february');
            case 2:
                return t('march');
            case 3:
                return t('april');
            case 4:
                return t('may');
            case 5:
                return t('june');
            case 6:
                return t('july');
            case 7:
                return t('august');
            case 8:
                return t('september');
            case 9:
                return t('october');
            case 10:
                return t('november');
            case 11:
                return t('december');
            default:
                return "";
        }
    };

    const initMonthList = () => {

        var month = [{name:'- ' + t('select month') + ' -',value:""}];
        var count = 12;
        const currentMonth = moment().month();
        const currentYear = moment().year();

        for (var i=currentMonth;i>=0;i--) {
            month.push({
                name: getNameOfMonth(i) + " " + currentYear,
                value: currentYear + "-" + (i<9 ? "0" + (i+1) : (i+1) ),
            });
            count--;
        }

        var j=0;
        while (count>0) {
            console.log("name: ",getNameOfMonth(11-j));
            month.push({
                name: getNameOfMonth(11-j) + " " + (currentYear-1),
                value: currentYear-1 + "-" + (j>2 ? "0" + (12-j) : (12-j) )     // value matching format of moment
            });
            count--;
            j++;
        }
        setMonthList(month);
    };

    const onSubmitHandler1 = (e) => {

        // validate form ...

        setIsSaving(true);
        let data;
        data = {
                client_id: Biscuit.get('user.client_id'),
                date: moment(selectedDate).format("YYYY-MM"),
                dateA: moment(selectedDate).format("YYYY-MM") + "-01 00:00:00"
            };
        let elem = document.getElementById(e.currentTarget.name);
        elem.classList.remove('hide');
        if(selectedLocation !== null){
            data.location_id = selectedLocation.id;
        }
        props.dispatch(accumulatedInvoiceActions.addAccumulatedInvoice({
                token: Biscuit.get('token'),
                data: data,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
        }));
    };

    const onSubmitHandler2 = (e) => {

        // validate form ...
        setIsSaving(true);
        let data;
        if(selectedBegin !== null && selectedEnd !== null) {
            data = {
                client_id: Biscuit.get('user.client_id'),
                date: moment(selectedBegin).format("YYYY-MM-DD"),
                endDate: moment(selectedEnd).format("YYYY-MM-DD"),
                exactDates: true
            };
        }
        let elem = document.getElementById(e.currentTarget.name);
        elem.classList.remove('hide');
        props.dispatch(accumulatedInvoiceActions.addAccumulatedInvoice({
            token: Biscuit.get('token'),
            data: data,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };
    const onCloseHandler = () => {

    };

    const onMonthSelectHandle = (value) => {
        value = value.target.value;
        const startOfMonth = moment(value).startOf('month').format('YYYY-MM-DD');
        setSelectedDate(startOfMonth);
        setSelectedMonth(value);
        setSelectedBegin(null);
        setSelectedEnd(null);
    }

    const onBeginChangedHandler = (date) => {
        setSelectedBegin(date);
        setSelectedMonth(null);
        setSelectedLocation(null);
    };

    const onEndChangedHandler = (date) => {
        setSelectedEnd(date);
        setSelectedMonth(null);
        setSelectedLocation(null);
    };

    const onLocationChangedHandler = (location) => {
        setSelectedLocation(location);
    };

    const onLocationQueryHandler = (query) => {
        props.dispatch(locationActions.getLocations({
            token: Biscuit.get('token'),
            filter: {
                findForSelect: true,
                q: query
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setLocationsPending(true);
    };
    const onPreview2ClickedHandler = (e) => {
        // validate for client
        if (Number(Biscuit.get('user.client_id')) === 7 && selectedLocation === null) {
            setNotification({show:true,message:t('You have to select a location.')});
            return;
        }
        if(selectedBegin === null){
            setNotification({show:true,message:t('You have to select a begin.')});
            return;
        }
        if(selectedEnd === null){
            setNotification({show:true,message:t('You have to select a end.')});
            return;
        }
        let elem = document.getElementById(e.currentTarget.name);
        elem.classList.remove('hide');
        const begin = moment(selectedBegin);
        const end = moment(selectedEnd);
        let params, filename;
        if (Number(Biscuit.get('user.client_id')) === 7) {
            params = "date=" + begin.format('YYYY-MM-DD') + "&endDate=" + end.format('YYYY-MM-DD') + "&location_id=" + selectedLocation.id + "&exactDates=true";
            filename = "Umsatzabrechnung_" + selectedLocation.name.replace(/\s/g, "_") + '_' + begin.format('DD._MMMM_YYYY') + "-" + end.format('DD._MMMM_YYYY') + + '.pdf';
        } else {
            params = "date=" + begin.format('YYYY-MM-DD') + "&endDate=" + end.format('YYYY-MM-DD') + "&client_id=" + Number(Biscuit.get('user.client_id')) + "&exactDates=true";
            if (Biscuit.get('user.role') === 'user') {
                filename = "Rechnung_" + begin.format('DD._MMMM_YYYY') + "-" + end.format('DD._MMMM_YYYY') + '.pdf';
            } else {
                filename = "Umsatzabrechnung_" + begin.format('DD._MMMM_YYYY') + "-" + end.format('DD._MMMM_YYYY') + '.pdf';
            }
        }
        generate(params, filename, e.currentTarget.name);
    }

    const generate = (params, filename,id) => {
        let elem = document.getElementById(id);
        const xmlHttp = new XMLHttpRequest();
        xmlHttp.open("GET", getApiHost() + '/sales_billings/generate?' + params, true);
        xmlHttp.setRequestHeader('Accept', 'application/json');
        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'));
        xmlHttp.responseType = 'blob';

        xmlHttp.onerror = function () {
            elem.classList.add('hide');
            setNotification({show:true, message:('orders_sales_billings_error')});
        };

        xmlHttp.onload = function () {

            if (xmlHttp.status === 500 || xmlHttp.status === 400) {
                elem.classList.add('hide');
                setNotification({show:true, message:t('orders_sales_billings_error')});
                return;
            }
            if (xmlHttp.status === 404 || typeof xmlHttp.response.size !== 'undefined' && xmlHttp.response.size === 13) {
                elem.classList.add('hide');
                props.showDelayedNotification('warning', 0, t('orders_sales_billings_error_no_reservations'));
                //let link = '<a href="#" onClick={props.linkHandler(_postSalesBilling.data.entity)}>'+_postSalesBilling.data.entity.invoice_nbr_major+'</a>';
                setNotification(
                    {
                        show: true,
                        message: t('orders_sales_billings_error_no_reservations')
                    });

                return;
            }

            const blob = new Blob([xmlHttp.response], {type: 'application/pdf'});
            elem.classList.add('hide');
            // Unfortunately, xmlHttp.getResponseHeader('Content-Disposition'); is null so we have to
            // re-create the file name

            FileSaver.saveAs(blob, filename);
        };

        xmlHttp.send(null);
    }
    const onPreviewClickedHandler = (e) => {

        // validate for client
        if (Number(Biscuit.get('user.client_id')) === 7 && selectedLocation === null) {
            setNotification({show:true,message:t('You have to select a location.')});
            return;
        }
        if(selectedDate === null){
            setNotification({show:true,message:t('You have to select a date.')});
            return;
        }
        let elem = document.getElementById(e.currentTarget.name);
        elem.classList.remove('hide');
        const date = moment(selectedDate);
        let params, filename;
        if (Number(Biscuit.get('user.client_id')) === 7) {
            params = "date=" + date.format('YYYY-MM') + "&location_id=" + selectedLocation.id;
            filename = "Umsatzabrechnung_" + selectedLocation.name.replace(/\s/g, "_") + '_' + date.format('MMMM_YYYY') + '.pdf';
        } else {
            params = "date=" + date.format('YYYY-MM') + "&client_id=" + Number(Biscuit.get('user.client_id'));
            if (Biscuit.get('user.role') === 'user') {
                filename = "Rechnung_" + date.format('DD._MMMM_YYYY') + '.pdf';
            } else {
                filename = "Umsatzabrechnung_" + date.format('MMMM_YYYY') + '.pdf';
            }
        }
        generate(params, filename,e.currentTarget.name);
    };

    useEffect(() => {

        if (isSaving === false) return;
        if (_postSalesBilling.success === true) {
            props.showDelayedNotification('success', _postSalesBilling.data.invoice_nbr);        // to-do: does not seem to work?
            //props.addItem(_postSalesBilling.data);
            //setShouldClose(true);
            let extra = ' #'+ _postSalesBilling.data.invoice_nbr;
            if(_postSalesBilling.data.invoice_nbr === null){
                extra = ' '+_postSalesBilling.data.name;
            }
            setNotification({ show: true, message: t('saved_${a}',{a:t('sales_billing')},'capital')+extra});
            setTimeout( () => {
                setShouldClose(true);
            },2000);
        } else {
            if(typeof _postSalesBilling.data !== 'undefined' && typeof _postSalesBilling.data.error !== 'undefined' && _postSalesBilling.data.error){
                props.showDelayedNotification('warning', 0, typeof _postSalesBilling.data !== 'undefined' ? t(_postSalesBilling.data.message) : null);
                //let link = '<a href="#" onClick={props.linkHandler(_postSalesBilling.data.entity)}>'+_postSalesBilling.data.entity.invoice_nbr_major+'</a>';
                setNotification(
                    {
                        show: true,
                        message: typeof _postSalesBilling.data !== 'undefined' ? t('invoice_exits_already_for_the_time_period_${a}',{a:''}): null,
                        link: _postSalesBilling.data.entity.invoice_nbr,
                        linkContent: _postSalesBilling.data.entity,
                        linkHandler: props._readFile
                    });
            } else if(typeof _postSalesBilling.data !== 'undefined' && typeof _postSalesBilling.data.code !== 'undefined' && _postSalesBilling.data.code == 404){
                props.showDelayedNotification('warning', 0, t('orders_sales_billings_error_no_reservations'));
                //let link = '<a href="#" onClick={props.linkHandler(_postSalesBilling.data.entity)}>'+_postSalesBilling.data.entity.invoice_nbr_major+'</a>';
                setNotification(
                    {
                        show: true,
                        message: t('orders_sales_billings_error_no_reservations')
                    });
            } else {
                props.showDelayedNotification('warning', 0, typeof _postSalesBilling.data !== 'undefined' ? t(_postSalesBilling.data.message) : null);
                setNotification({ show: true, message: typeof _postSalesBilling.data !== 'undefined' ? t(_postSalesBilling.data.message) : null});
            }
            let elems = document.getElementsByClassName('roll');
            _.each(elems,function(elem){
                if(!elem.classList.contains('hide')) {
                    elem.classList.add('hide');
                }
            });

            setIsSaving(false);
            return;
        }
    }, [_postSalesBilling]);

    useEffect(() => {

        if (locationsPending === false || _locations.success == '') return;

        if (_locations.success === true) {
            setLocations([..._locations.data]);
        } else if (_locations.success === false) {
            props.showDelayedNotification('warning', 0, typeof _locations.data !== 'undefined' ? t(_locations.data.message) : null);
        }
        setLocationsPending(false);
    },[_locations]);

    const initialize = () => {

        if (Number(Biscuit.get('user.client_id')) === 7) {
            // get locations to select
            props.dispatch(locationActions.getLocations({
                token: Biscuit.get('token'),
                filter: {
                    findForSelect: true,
                    find: 'short',
                    limit: 999,
                    page: 1
                },
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setLocationsPending(true);
        }
        setInitialized(true);
        initMonthList();
    };

    if (initialized === false) initialize();

    return (
        <>
            <div className='js-off-canvas-overlay is-overlay-fixed is-visible'></div>
            {notification.show &&
            <>
                <Notification
                    message={notification.message}
                    onCloseHandler={onCloseNotificationHandler}
                    link={notification.link}
                    linkHandler={notification.linkHandler}
                    linkContent={notification.linkContent}
                >
                </Notification>
            </>
            }
            <div className="off-canvas position-right is-transition-overlap is-open" id="inb-off-canvas" data-off-canvas="85mrb3-off-canvas" data-close-on-click="false" aria-hidden="false">
                <OffcanvasHeader
                    heading={t('create_${a}',{a:t('sales_billing')})}
                    item={{}}
                    dispatch={props.dispatch}
                    onSubmitHandler={onSubmitHandler1}
                    noSaveButton={true}
                    onCloseHandler={onCloseHandler}
                    shouldClose={shouldClose}
                    returnUrl="/finances/sales_billings"
                    isSaving={isSaving}/>
                <form className="off-content row">
                    <div className="inb-form-group column medium-12 small-12">
                        <p>{t('month selection')}</p>
                    </div>
                    <FormItem
                        name="finances-sales-billings-date"
                        label={t('date')}
                        type="select"
                        data={monthList}
                        dataKey="value"
                        selected={selectedMonth === "" ? selectedMonth : undefined}
                        mediumWidth={(Number(Biscuit.get('user.client_id')) === 7)?4:8}
                        smallWidth={6}
                        onChangeHandler={onMonthSelectHandle}
                        extraTopClasses=""/>

                    {Number(Biscuit.get('user.client_id')) === 7 &&    
                        <FormItem
                            name="finances-sales-billings-location"
                            type="select2"
                            label={t('location')}
                            placeholder={t('Standort wählen')}
                            data={locations}
                            dataKey="id"
                            onQueryHandler={onLocationQueryHandler}
                            onChangeHandler={onLocationChangedHandler}
                            mediumWidth={4}
                            smallWidth={12}
                            extraTopClasses=""/>
                    }
                    <FormItem
                        name="finances-sales-billings-preview-first"
                        type="button"
                        label={t('preview')}
                        link="#"
                        icon=""
                        beautify={true}
                        round={true}
                        onChangeHandler={onPreviewClickedHandler}
                        mediumWidth={2}
                        smallWidth={6}
                        extraTopClasses=""/>
                   {/* <FormItem
                        name="finances-sales-billings-save1"
                        type="button"
                        label={t('save')}
                        link="#"
                        icon=""
                        beautify={true}
                        round={true}
                        onChangeHandler={onSubmitHandler1}
                        mediumWidth={2}
                        smallWidth={6}
                        extraTopClasses=""/>*/}
                    {Number(Biscuit.get('user.client_id')) !== 7 &&  <><div className="inb-form-group column medium-12 small-12">
                        <hr/>
                        <p>{t('timeperiod selection')}</p>
                    </div>
                    <FormItem
                        name="finances-sales-billings-begin"
                        type="datePicker"
                        label={t('begin')}
                        placeholder=""
                        selected={selectedBegin}
                        dateFormat="dd.MM.y"
                        datePickerClass="noBorders-noBackground"
                        onChangeHandler={onBeginChangedHandler}
                        mediumWidth={4}
                        smallWidth={12}
                        extraTopClasses=""/>
                    <FormItem
                        name="finances-sales-billings-end"
                        type="datePicker"
                        label={t('end')}
                        placeholder=""
                        selected={selectedEnd}
                        dateFormat="dd.MM.y"
                        datePickerClass="noBorders-noBackground"
                        onChangeHandler={onEndChangedHandler}
                        mediumWidth={4}
                        smallWidth={12}
                        extraTopClasses=""/>
                    <FormItem
                        name="finances-sales-billings-preview"
                        type="button"
                        label={t('preview')}
                        link="#"
                        icon=""
                        beautify={true}
                        round={true}
                        onChangeHandler={onPreview2ClickedHandler}
                        mediumWidth={2}
                        smallWidth={6}
                        extraTopClasses=""/>
                    {/*<FormItem
                        name="finances-sales-billings-save2"
                        type="button"
                        label={t('save')}
                        link="#"
                        icon=""
                        beautify={true}
                        round={true}
                        onChangeHandler={onSubmitHandler2}
                        mediumWidth={2}
                        smallWidth={6}
                        extraTopClasses=""/>*/}
                    </>}
                </form>
            </div>
        </>
    );
};

export default AddSalesBillingsView;